import { getDurationInMonths } from '@helpers/GetDurationInMonths/getDurationInMonths';

import { TAccount } from './accounts.types';
import { getAccountIsInterestOnly } from './getAccountIsInterestOnly';

/**
 * Determines if an account is a credit_facility or flexi24 product type and the duration is >12 months and it is not an interest-only account
 * @param account: TAccount- An Account object
 * @returns true or false
 */
export const getAccountIsFlexiLoan = (account: TAccount) => {
    if (getAccountIsInterestOnly(account)) return false;
    return Boolean(
        ['credit_facility', 'flexi24'].includes(account.product_type) &&
            getDurationInMonths(account.duration!) >= 12
    );
};
